import React, {Component} from 'react';
import Form from 'react-bootstrap/Form';
import alert from 'react-bootstrap/Alert';
import DatePicker from "react-datepicker";
import FirebaseService from '../../services/firebase';
import './style.css';
import "react-datepicker/dist/react-datepicker.css";


class NewSpot extends Component {
    admins = [];
    adminOptions = [];
    adictOptions = [];
    
    
    constructor(props) {
      super(props);
      console.dir(props.location.state, !!props.location.state);
      if (!!props.location.state) {
            props.location.state.date = new Date(props.location.state.date.seconds*1000)
            this.state = props.location.state;
      } else {
            this.state = {
                addictionId: 'alcohol',
                admin: '',
                date: new Date(),
                id: null,
                link: '',
                status: 'active',
                users: []
            }; 
      }
      this.getAdmins();
      this.getAddicts();
    }

    handleSubmit = (event) => {
        event.preventDefault();

        FirebaseService.setMeeting(this.state).then(() => {
            this.props.history.push('/dashboard')
        })
    }

    async getAdmins() {
        const admins = await FirebaseService.getAdmins();
        admins.forEach(admin => {
            !this.state.admin && (this.state.admin = admin.id);
            this.adminOptions.push(<option value={admin.id}>{admin.id}</option>)
        })
        this.setState({admins})
    }

    async getAddicts() {
        const addicts = await FirebaseService.getAddicts();
        addicts.forEach(addict => {
            let addictData = addict.data();
            !this.state.addictionId && (this.state.addictionId = addictData.name);
            this.adictOptions.push(<option value={addictData.name}>{addictData.pt}</option>)
        })
        this.setState({addicts})
    }




    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <Form.Group controlId="addictionId">
                    <Form.Label>Addiction</Form.Label>
                    <Form.Control as="select" 
                        value={this.state.addictionId} 
                        onChange={event => this.setState({addictionId: event.target.value})}
                    >
                        {this.adictOptions}
                    </Form.Control>
                </Form.Group>

                <Form.Group controlId="admin">
                    <Form.Label>Admin</Form.Label>
                    <Form.Control as="select" 
                        value={this.state.admin} 
                        onChange={event => this.setState({admin: event.target.value})}
                    >
                        {/* <option value=''>Selecione uma opção</option> */}
                        {this.adminOptions}
                    </Form.Control>
                </Form.Group>

                <label htmlFor="">Data *</label>
                <DatePicker
                    selected={this.state.date}
                    onChange={date => this.setState({date})}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={60}
                    timeCaption="time"
                    dateFormat="d MMMM, yyyy h:mm aa"
                />

                <Form.Group controlId="limit">
                    <Form.Label>Limite</Form.Label>
                    <Form.Control 
                        type="number"
                        value={this.state.limit} 
                        onChange={event => this.setState({limit: event.target.value})} />
                </Form.Group>

                <Form.Group controlId="link">
                    <Form.Label>Link</Form.Label>
                    <Form.Control 
                        type="text"
                        value={this.state.link} 
                        onChange={event => this.setState({link: event.target.value})} 
                        placeholder="https://meet.google.com/sce-tpjk-wfj" />
                </Form.Group>
                
                <button className="btn" type="submit">Salvar</button>

            </form>
        );
    }
  }

  export default NewSpot;
